import React, { useState, useEffect } from 'react';

import { makeStyles } from '@mui/styles';

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFilter } from "@fortawesome/pro-light-svg-icons";

import Interpolator from './Interpolator';


const useStyles = makeStyles(theme => ({   
    
    outerRow: {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'space-between', 
        alignItems: 'flex-center',
        marginLeft: '.5em',
        //marginTop: '.5em',       
        backgroundColor:'#FFCB66',
        padding: '.5em',
        paddingTop:'1em',
        //width:'100%',
        borderRadius: '3px',
        fontSize: '9pt',
        width: '358px',

    },

    selects: {
        marginLeft: '.5em',
        marginRight: '.5em',
        
    }, 
    filterRow : {
        fontFamily:'Mulish', 
        display: 'flex', 
        flexDirection: 'row',         
        justifyContent: 'flex-start', 
        alignItems: 'flex-center',  
        width: '370px',
          
    },

    filterButton: {
        marginRight: '7vw'
    },

    invoiceNoInput: {
        width: '130px',
                
    }


    }));

    


const Filter = (props) => {
    const classes = useStyles();
  
    const [period, setPeriod] = useState("Alle");
    const [paymentStatus, setPaymentStatus] = useState("Alle");
    const [invoiceNo, setInvoiceNo] = useState('');

   
    useEffect(() =>  {  //runs when filters are applied
    
        var filter = {};
        filter.period=period;
        filter.invoiceNo = invoiceNo;
        // filter.paymentStatus=paymentStatus;
        props.setFilter(filter); //sends updated filter back to InvoiceMainView
        
    },[period, invoiceNo, paymentStatus]) 

    const getYears = () => {

        const yearArray = [];
        const thisYear = new Date().getFullYear();

        for (let i = 0; i < 5; i++) {
            yearArray[i] = thisYear-i;
        } 

        return yearArray;
    }


    return(              
        <div className={classes.outerRow}> 

            <div className={classes.filterRow}>
            <FontAwesomeIcon icon={faFilter} size='2x' /> &nbsp; 

            {props.isFetchingChunked && <div>Filter: Viser <br/> <Interpolator targetNo={props.noOfInvoicesShowing}/>av ...<br/>Faktura </div> }
            {!props.isFetchingChunked && <div>Filter: Viser <br/> {props.noOfInvoicesShowing} av<br/> {props.totalNoOfInvoices} Faktura </div> }
                          

            <FormControl  fullwidth >
            <InputLabel id="periodPicker" >Periode</InputLabel>
            <Select
                labelId="PeriodPicker"
                id="invoiceHotelPeriodPicker"
                value={period}
                label="Periode"
                onChange={e => setPeriod(e.target.value)}                
                size='small' 
                style={{ fontSize: '8pt' }} 
                className={classes.selects}
                              
            >
                <MenuItem value={"Alle"}>Alle</MenuItem>
                <MenuItem value={"Siste Måned"}>Siste Måned</MenuItem>
                <MenuItem value={"3 Måneder"}>3 Måneder</MenuItem>
                <MenuItem value={"6 Måneder"}>6 Måneder</MenuItem>              

                {getYears().map((item,i) => <MenuItem key={i} value={item}>{item}</MenuItem>)} // map the last 5 years to menu items
            </Select>
                        
            </FormControl>


            <TextField 
                inputProps={{style:{height: '15px',fontSize: '10pt',}}} 
                InputLabelProps={{style: {fontSize: 12}}}
                className={classes.invoiceNoInput} onChange={e => setInvoiceNo(e.target.value)} 
                variant="outlined" label="Søk FakturaNr" size='small'>
            </TextField>

           

            </div>
           

        </div>
    )
};

export default Filter;